import { createStore } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // to save data in the browser's local storage
import rootReducer from "./reducers";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["user"]  // only save the user's login info
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(persistedReducer);

export const persistor = persistStore(store);

export default store;